import React from 'react'

import { Text } from '@chakra-ui/react'
import { Button } from 'src/components/__legacy__/button/button'
import { Message } from 'src/components/__legacy__/message/message'
import { Modal } from 'src/components/__legacy__/modal/modal'
import { ModalActions } from 'src/components/__legacy__/modal/modal-actions'
import { ModalContent } from 'src/components/__legacy__/modal/modal-content'
import { ModalTitle } from 'src/components/__legacy__/modal/modal-title'
import { Spacer } from 'src/components/__legacy__/spacer/spacer'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { useConfirmCrf } from './use-confirm-crf'
import { useCrfUpload } from '../crf-upload-context'

type Props = {
  trialUid: string
  onComplete: () => void
  onClickPrev: () => void
}

export const ConfirmComponent: React.FC<Props> = props => {
  const { trialUid, onComplete, onClickPrev } = props
  const { request, requesting, errorMessage } = useConfirmCrf()
  const {
    state: { folderTemplates },
  } = useCrfUpload()
  const toast = useMirohaToast()

  const onConfirm = async () => {
    if (!folderTemplates) return

    try {
      await request({
        trialUid,
        crfFolderTemplateUid: folderTemplates.crfFolderTemplateUid,
      })

      onComplete()
      toast({ status: 'success', title: 'CRFをeSourceへ反映しました。' })
    } catch {
      /* empty */
    }
  }

  return (
    <Modal onClose={onClickPrev} closable={!requesting}>
      <ModalTitle title="反映確認" />

      <ModalContent>
        <Text textAlign="center">CRFをMiROHA eSourceへ反映しますか？</Text>
        <Spacer size={10} />
        <Text fontSize="xs" textAlign="center">
          *既存のeSourceフォルダ、テンプレートはすべてクリアされます。
        </Text>
      </ModalContent>

      <ModalActions>
        <Button
          size="S"
          text="戻る"
          onClick={onClickPrev}
          buttonType="normal"
          disabled={requesting}
        />
        <Spacer size={40} horizontal />
        <Button
          size="S"
          text="確定"
          onClick={onConfirm}
          buttonType="important"
          disabled={requesting}
        />
      </ModalActions>

      {errorMessage && (
        <div>
          <Spacer size={8} />
          <Message type="error" message={errorMessage} centered />
        </div>
      )}
    </Modal>
  )
}
